import { makeStyles, Theme } from '@material-ui/core/styles';
const styles = makeStyles(({ spacing, palette, typography, variables, schema, breakpoints }: Theme) => ({
    jetButton: {
        '&.jetButton__size__large': {
            height: '56px !important',
            fontSize:`${typography?.button?.buttonLSize?.fontSize} !important`,
            lineHeight:typography?.button?.buttonLSize?.lineHeight,
            fontWeight: `${typography.button?.buttonLWeight} !important`,
        },
        '&.jetButton__size__medium': {
            height: '48px',
            fontSize:`${typography?.button?.buttonMSize?.fontSize} !important`,
            lineHeight:typography?.button?.buttonMSize?.lineHeight,
            fontWeight: `${typography.button?.buttonMWeight} !important`,
        },
        '&.jetButton__size__small': {
            height: '40px',
            fontSize:`${typography?.button?.buttonSSize?.fontSize} !important`,
            lineHeight:typography?.button?.buttonSSize?.lineHeight,
            fontWeight: `${typography.button?.buttonSWeight} !important`,
        },
        '&.jetButton__size__xsmall': {
            fontSize:`${typography?.button?.buttonXsSize?.fontSize} !important`,
            lineHeight:typography?.button?.buttonXsSize?.lineHeight,
            fontWeight: `${typography.button?.buttonXsWeight} !important`,
            height: '32px',
            '& .MuiButton-label': {
                paddingLeft: '0px',
                paddingRight: '0px',
            },
        },
      
        '& .MuiTouchRipple-root': {
            display: 'none'
        },
        '& .MuiButton-label': {
            textTransform: 'none',
            [breakpoints.down('md')]:{
                paddingLeft:variables?.spacingB,
                paddingRight:variables?.spacingB
            },
            paddingLeft:variables?.spacingC,
            paddingRight:variables?.spacingC
        },
        '&.MuiButton-text':{
            padding:'unset'
        },
        '&.MuiButton-root':{
            lineHeight:'1.3'
        },
        '&:hover': {
            background: `linear-gradient(
            rgba(0, 0, 0, ${palette.jet?.hover01}), 
            rgba(0, 0, 0, ${palette.jet?.hover01})
            )`,
            [breakpoints.up('md')]:{
                outline: `none`
            }
        },
        '&:active': {
            outline: `2px solid ${palette.jet?.focusOuter} !important`,
            background: `linear-gradient(
                rgba(0, 0, 0, ${palette.jet?.active01}), 
                rgba(0, 0, 0, ${palette.jet?.active01})
              )`,
            border: 'none'
        },
        '&.Mui-disabled': {
            backgroundColor: `${palette.jet?.disabled01} !important`,
            color: `${palette.jet?.contentDisabled} !important`,
            border: 'none !important'
        },
    },
    jetButton__primary_dark: {
        border: 'none',
        backgroundColor: `${palette.jet?.interactivePrimary} !important`,
        color: `${palette.jet?.contentInteractivePrimary} !important`,
        borderRadius: `${variables?.radiusRoundedE} !important`,
        minWidth: '91px !important',
        fontWeight: `${variables?.fontWeightBold}!important` as any,
        textTransform: 'capitalize !important' as any,
        fontSize: schema?.buttonSSize,
    },
    jetButton__primary: {
        border: 'none',
        backgroundColor: `${palette.jet?.interactiveBrand} !important`,
        color: `${palette.jet?.contentInteractivePrimary} !important`,
        borderRadius: `${variables?.radiusRoundedE} !important`,
        minWidth: '91px !important',
        fontWeight: `${variables?.fontWeightBold}!important` as any,
        textTransform: 'capitalize !important' as any,
        fontSize: schema?.buttonSSize,
    },
    jetButton__ghost: {
        border: 'none !important',
        backgroundColor: `none !important`,
        color: `${palette.jet?.contentLink} !important`,
        borderRadius: `${variables?.radiusRoundedE} !important`,
        minWidth: '91px !important',
        fontWeight: `${variables?.fontWeightBold}!important` as any,
        textTransform: 'capitalize !important' as any,
        fontSize: schema?.buttonSSize,
    },
    jetButton__default: {
        border: 'none !important',
        backgroundColor: `${palette.jet?.interactiveSecondary} !important`,
        color: `${palette.jet?.contentLink} !important`,
        borderRadius: `${variables?.radiusRoundedE} !important`,
        minWidth: '91px !important',
        fontWeight: `${variables?.fontWeightBold} !important` as any,
        textTransform: 'capitalize !important' as any,
        fontSize: schema?.buttonSSize,
    },
    jetButton__textbutton: {
        border: 'none !important',
        fontSize: schema?.buttonLSize,
        color: `${palette.jet?.contentDisabled} !important`,
        '&:hover': {
            border: 'none !important',
            outline: 'none !important',
            color: `${palette.jet?.contentInverse} !important`,
        }
    },
    jetButton__ghostbutton: {
        outline: 'none !important',
        fontSize: schema?.buttonLSize,
        color: `${palette.jet?.contentInteractiveDark} !important`,
        width:'auto',
        padding:`${variables?.spacingB} ${variables?.spacingD} !important`,
        borderRadius: `${variables?.spacingNone} !important`,
        background: 'inherit',
        transition: 'inherit !important',
        '&:hover': {
            outline: 'none !important',
            borderRadius: `${variables?.spacingE} !important`,
            border: 'inherit',
            color: `${palette.jet?.contentInteractiveDark} !important`,
        },
        '&:active': {
            border: 'inherit',
            borderRadius: `${variables?.spacingE} !important`,
            outline: 'none !important',
        },
        '&:focus': {
            border: 'inherit',
            borderRadius: variables?.spacingE,
            outline: 'none !important',
        }
    },
    jetButton__support: {
        border: 'none !important',
        backgroundColor: `${palette.jet?.supportError} !important`,
        color: `${palette.jet?.contentInteractiveLight} !important`,
        borderRadius: `${variables?.radiusRoundedE} !important`,
        minWidth: '48px',
        width:'auto',
        fontWeight: `${variables?.fontWeightBold}!important` as any,
        textTransform: 'capitalize !important' as any,
        fontSize: schema?.buttonMSize,
        padding: `${variables?.spacingB} ${variables?.spacingE} !important`,
        gap:0,
        '& .MuiButton-label': {
            paddingLeft:'0',
            paddingRight: '0'
        }
    },
}))


export default styles;